<template>
       <!-- Start Main Content -->
       <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card p-0 lg:min-h-[calc(100vh_-_theme('spacing.header')_*_1.4)] xl:min-h-[calc(100vh_-_theme('spacing.header')_*_1.6)]">
            <div class="flex flex-col gap-2 sm:flex-center-between sm:flex-row px-4 py-5 sm:p-7 bg-gray-200/30 dark:bg-dark-card-shade">
                <div>
                    <h6 class="card-title">Employee</h6>
                </div>
                <a href="#" class="btn b-solid btn-primary-solid" data-modal-target="editModal" @click="addModal()">Add Employee</a>
            </div>

    <div class="card p-2">
            <div class="flex flex-wrap items-center space-y-4 lg:space-y-0 lg:space-x-4">
                <!-- Start Date -->
                <div class="w-full lg:w-auto">
                    <label for="startDate" class="block text-sm font-medium text-gray-700 ">From Date</label>
                    <input
                        type="date"
                        id="startDate"
                        v-model="filter.startDate"
                        class="w-full p-2 border border-gray-300 rounded "
                    />
                </div>

                <!-- End Date -->
                <div class="w-full lg:w-auto">
                    <label for="endDate" class="block text-sm font-medium text-gray-700 ">To Date</label>
                    <input
                        type="date"
                        id="endDate"
                        v-model="filter.endDate"
                        class="w-full p-2 ml-2 mb-4 border border-gray-300 rounded "
                    />
                </div>


        <div class="w-full lg:w-auto flex justify-center lg:justify-start">
                            <button
                                type="submit"
                                @click="getFilterBasics"
                                class="btn btn-primary-solid px-5 mt-2 ml-4 mb-2 lg:mt-5 lg:ml-3 w-full lg:w-auto cursor-pointer"
                            >
                                Filter
                            </button>
                        </div>





    </div>



        </div>








            <!-- Start All Language List Table -->
            <div class="p-3 sm:p-4">
                <div class="overflow-x-auto scrollbar-table">
                    <table class="table-auto w-full whitespace-nowrap text-left text-gray-500 dark:text-dark-text leading-none datatable" id="basicDataTable" >
                        <thead class="border-b border-gray-200 dark:border-dark-border font-semibold">
                            <tr>
                                <th class="px-3.5 py-4">emp code</th>
                                <th class="px-3.5 py-4">emp name</th>
                                <th class="px-3.5 py-4">emp contact</th>
                                <th class="px-3.5 py-4">emp pwd</th>
                                <th class="px-3.5 py-4">emp role</th>
                                <th class="px-3.5 py-4">Staus</th>
                                <th class="px-3.5 py-4">Total</th>
                                <th class="px-3.5 py-4">Paid</th>
                                <th class="px-3.5 py-4">Due</th>
                                <th class="px-3.5 py-4">Processing</th>
                                <th class="px-3.5 py-4">Pending</th>
                                <th class="px-3.5 py-4">Action</th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                            <tr class="hover:bg-primary-200/50 dark:hover:bg-dark-icon hover:text-gray-500 dark:hover:text-white" v-for="(item ,index)  in empList" :key="item.id" > 
                                <td class="px-3.5 py-4">{{item.empcode}}</td>
                                <td class="px-3.5 py-4">
                                    <router-link :to="`/emphistory?q=${item.id}`" class="text-black-500 underline">
                                        {{ item.empname }}
                                    </router-link>
                                </td>
                                <td class="px-3.5 py-4">{{item.empcontact}}</td>
                                <td class="px-3.5 py-4">{{item.emppwd}}</td>
                                  <td class="px-3.5 py-4">
                                {{ item.emprole == 3 ? 'Admin' : (item.emprole == 2 ? 'Tailor' : (item.emprole==1 ? 'Employee' : '')) }}
                                </td>
                                 <td class="px-3.5 py-4">
                                {{ item.empstatus == 1 ? 'Active' : (item.empstatus == 2 ? 'Deactive' : '') }}
                                </td>
                                    <td class="px-3.5 py-4">{{item.total_sum}}</td>
                                    <td class="px-3.5 py-4">{{item.paid_sum}}</td>
                                 <td class="px-3.5 py-4">{{ (item.total_sum - item.paid_sum).toFixed(2) }}</td>
                                    <td class="px-3.5 py-4">{{item.processing_cnt}}</td>
                                    <td class="px-3.5 py-4">{{item.complete_cnt}}</td>

                                <td class="px-3.5 py-4">
                                    <div class="flex items-center gap-1">
                                        <button class="btn-icon btn-primary-icon-light size-7"  @click="editModal(item)"  >
                                            <i class="ri-edit-2-line text-inherit text-[13px]"></i>
                                        </button>
                                        <button class="btn-icon btn-danger-icon-light size-7" @click="deleteModal(item.id)" >
                                            <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                                        </button>
                                       <button class="btn-icon btn-success-icon-light size-7" @click="salaryModal(item)">
                                            <i class="ri-add-line text-success text-[13px]"></i>
                                        </button>

                                  <button class="btn-icon btn-primary-icon-light size-7" @click="salaryreport(item.id)">
                                    <i class="ri-eye-line text-blue-600 text-[13px]"></i>
                                </button>


                                    </div>
                                </td>
                            </tr>
                            
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- End All Language List Table -->
        </div>
    </div>
    <!-- End Main Content -->

    <!-- Start Edit Modal -->
    <div id="editModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-lg max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5">
                   
                        <div class="mt-7">
                            <label for="tagname" class="form-label">emp code *</label>
                            <input type="number" v-model="emp.empcode" class="form-input" id="first_input" placeholder="Employee Name" autocomplete="off" ref="field1" @keyup.enter="$refs.field2.focus()" required >
                        </div>


                     <div class="mt-7">
                            <label for="tagname" class="form-label">emp name *</label>
                            <input type="text" v-model="emp.empname" class="form-input" id="first_input" placeholder="Employee Name" autocomplete="off" ref="field2" @keyup.enter="$refs.field3.focus()"required >
                        </div>

                          <div class="mt-7">
                            <label for="tagname" class="form-label">emp contact *</label>
                            <input type="number" v-model="emp.empcontact" class="form-input" id="first_input" placeholder="Employee Contact" ref="field3" @keyup.enter="$refs.field4.focus()" autocomplete="off" required >
                        </div>

                           <div class="mt-7">
                            <label for="tagname" class="form-label">emp pwd *</label>
                            <input type="text" v-model="emp.emppwd" class="form-input" id="first_input" placeholder="Employee Password" autocomplete="off" ref="field4" @keyup.enter="$refs.field5.focus()"  required >
                        </div>

                        
                           <div class="mt-7">
                            <label for="tagname" class="form-label">emp role *</label>
                           <select   v-model="emp.emprole" class="form-input" ref="field5"  @change="$refs.field6.focus()">
                                <option value="3">Admin</option>
                                 <option value="1">Employee</option>
                                <option value="2">Tailor</option>
                            </select>
                        </div>


                        <div class="mt-7">
                            <label for="tagname" class="form-label">Category Status *</label>
                            <select   v-model="emp.empstatus" class="form-input" ref="field6" @change="$refs.saveBtn.focus()">
                                <option value="1">Active</option>
                                <option value="2">Deactive</option>
                            </select>

                        </div>
                        <div class="flex justify-end mt-7">
                            <button @click="save_category" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm" ref="saveBtn">Save</button>
                        </div> 
                </div>
            </div>
        </div>
    </div>
    <!-- End Edit Modal -->

    <!-- Start Delete Modal -->
    <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Delete Modal -->

<!-- emp salary -->
     <!-- Start Edit Modal -->
    <div id="salaryModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-lg max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5">


                      <div class="mt-7">
                            <label for="tagname" class="form-label">Entry Date *</label>
                            <input type="date" v-model="salary.entrydate" class="form-input" id="first_input" placeholder="Type Here" autocomplete="off" ref="salary1" @keyup.enter="$refs.salary2.focus()" required >
                        </div>
                   
                        <div class="mt-7">
                            <label for="tagname" class="form-label">Paid *</label>
                            <input type="number" v-model="salary.paid" class="form-input" id="first_input" placeholder="Type Here" autocomplete="off" ref="salary2" @keyup.enter="$refs.salary3.focus()" required >
                        </div>


                     <div class="mt-7">
                            <label for="tagname" class="form-label">Total *</label>
                            <input type="number" v-model="salary.total" class="form-input" id="first_input" placeholder="Type Here" autocomplete="off" ref="salary3" @keyup.enter="$refs.salary4.focus()"  required >
                        </div>

                          <div class="mt-7">
                            <label for="tagname" class="form-label">Note *</label>
                            <input type="text" v-model="salary.note" class="form-input" id="first_input" placeholder="Type Here" autocomplete="off" ref="salary4" @keyup.enter="$refs.savebtn.focus()" required >
                        </div>

                        <div class="flex justify-end mt-7">
                            <button @click="save_salary" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm" ref="savebtn">Save</button>
                        </div> 
                </div>
            </div>
        </div>
    </div>
    <!-- End Edit Modal -->

<!-- emp salary -->








</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
  name: 'ProductCategory',
  components: {
    
  } ,
  mounted(){
    this.getBasics();
  },
  data() {
        const today = new Date().toISOString().split('T')[0];
    return {
        isAdd:0,
        isEdit:0,
        isDelete: 0,
        deleteId:0,
        empList:[],
        emp:{
            empcode:'',
            empname:'',
            empcontact:'',
            emppwd:'',
            emprole:'',
            empstatus:'1',
        },
        salary:{
            entrydate:new Date().toISOString().split('T')[0],
            paid:'',
            total:'',
            note:'',
        },

        filter:{
            startDate:this.getStartDate(),
            endDate:today
        },

        employees: {empname:'',emprole:'0',isMainAdmin:0},
    }
    }, 
  methods:{
     getStartDate() {
      let startDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
      //startDate.setDate(1); // Set to the 1st of the month
      return startDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    },
    closeModal(){
      //  alert("hello");
        
            $("#editModal").addClass('hidden');
            $("#deleteModal").addClass('hidden');
            $("#salaryModal").addClass('hidden');

        this.isAdd=0;
        this.isEdit=0;
        this.isDelete=0;
        this.deleteId=0;
    },
    addModal(){
       // this.cat={name:'',status:'Active'};

         this.emp={
            empcode:'',
            empname:'',
            empcontact:'',
            emppwd:'',
            emprole:'',
            empstatus:'1',
        };

        if(!this.isAdd)
            $("#editModal").removeClass('hidden');
        else
            $("#editModal").addClass('hidden');
            $("#first_input").focus();
        this.isAdd=!this.isAdd;
    },

    editModal(item){
        if(item){
            let copy = JSON.parse(JSON.stringify(item));
            this.emp=copy;
        }
        if(!this.isEdit)
            $("#editModal").removeClass('hidden');
        else
            $("#editModal").addClass('hidden');
        this.isEdit=!this.isEdit;
    },

     salaryModal(item){

            // this.salary = {
            //     entrydate:new Date().toISOString().split('T')[0],
            //     empid: item.id, 
            //     paid: '',      
            //     total: '',
            //     note: ''
            // };

        //  if(item){
        //     let copy = JSON.parse(JSON.stringify(item));
        //     this.salary=copy;
        // }
     
        if(!this.isAdd)
            $("#salaryModal").removeClass('hidden');
        else
            $("#salaryModal").addClass('hidden');
        this.isAdd=!this.isAdd;
    },
    
    deleteModal(id){
        this.deleteId=id;
        if(!this.isDelete)
            $("#deleteModal").removeClass('hidden');
        else
            $("#deleteModal").addClass('hidden');
        this.isDelete=!this.isDelete;
    },
    async getBasics() {
          var self=this;
            axios.post('getemplist').then(function (response) {
                 self.destroyDatatble();
                    self.empList=response.data.empList;
                    self.employees=response.data.userDetails;
                   }).then(()=>{


                    self.refreshDatatble();


                      });
     },
     save_category() {
                var self = this; 
                axios.post('save_employee', this.emp)
                    .then(response => {
                         self.destroyDatatble();
                        var msg = response.data.msg;
                        var isSuccess = response.data.status;
                        self.empList=response.data.empList;
                        self.employees=response.data.userDetails;
                        //self.cat={name:'',status:'Active'};

                          self.emp={ empcode:'', empname:'',empcontact:'',emppwd:'',emprole:'',empstatus:'1'};

                        self.$swal(msg);
                        if (isSuccess == 1) {
                            self.closeModal();
                        }
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    }).then(()=>{
                                self.refreshDatatble();
                                 });
            },
            delete_category() {
                var self = this; 
                axios.post('deleteemp', {deleteId:this.deleteId})
                    .then(response => {
                      self.destroyDatatble();
                        self.empList=response.data.empList;
                        self.employees=response.data.userDetails; 
                         self.closeModal(); 
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    }).then(()=>{
                                self.refreshDatatble();
                                 });
            },


    save_salary() {
                var self = this; 
                axios.post('save_salary', this.salary)
                    .then(response => {
                          self.destroyDatatble();
                        var msg = response.data.msg;
                        var isSuccess = response.data.status;
                        self.empList=response.data.empList;
                        self.employees=response.data.userDetails;
               
                    self.salary={entrydate:'',paid:'', total:'',note:'',},

                        self.$swal(msg);
                        if (isSuccess == 1) {
                            self.closeModal();
                        }
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    }).then(()=>{
                                self.refreshDatatble();
                                 });
            },



            salaryreport(id){

            this.$router.push(`/salaryReport?q=${id}`);


            },


             refreshDatatble() {
               self.datatable= $(".datatable").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false 
                            });
         },
          destroyDatatble() {
                 if ($.fn.dataTable.isDataTable('.datatable')) {
                        $('.datatable').DataTable().destroy();
                    }
          },


           getFilterBasics() {
         var self=this;
            axios.post('getFilterEmp',self.filter).then(function (response) {
                self.destroyDatatble();
                   self.empList=response.data.empList;
                    self.employees=response.data.userDetails;
                }).then(()=>{
                    self.refreshDatatble();

          
                    });
  },

  


  }
}
</script>
